module.exports = __webpack_public_path__ + "8ad241607e3e6e2b03afcd1748cd2e1e.svg";